import React from "react";
import blue from "material-ui/colors/blue";
import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import { connect } from "react-redux";
import { Button, CircularProgress } from "material-ui";
import { withRouter, RouteComponentProps } from "react-router";
import {
    ActionButtonClicked,
    actionButtonDisabled,
    getActionButton,
    actionButtonShowSpinner,
} from "../../ducks/actionbutton";

interface IActionButtonProps extends RouteComponentProps<{}> {}

interface IActionButtonReduxProps {
    text?: string;
    icon?: {};
    disabled: boolean;
    showSpinner: boolean;
    className?: string | "";
}

interface IActionButtonDispatchProps {
    actionButtonClick: () => void;
}

interface IActionButtonState {}

type ActionButtonProps = IActionButtonProps &
    IActionButtonReduxProps &
    IActionButtonDispatchProps;

class ActionButton extends React.Component<
    ActionButtonProps,
    IActionButtonState
> {
    constructor(props: ActionButtonProps) {
        super(props);
    }

    onClick = () => {
        this.props.actionButtonClick();
    };

    render() {
        const { disabled } = this.props;

        return (
            <div className={`action-button`}>
                <Button
                    className={this.props.className}
                    style={{ minWidth: 0 }}
                    disabled={disabled}
                    aria-label={this.props.text || ""}
                    onClick={this.onClick}
                >
                    {this.props.text || ""}
                    {this.props.icon}
                    {this.props.showSpinner && this.props.disabled && (
                        <CircularProgress
                            size={24}
                            style={{
                                color: blue[500],
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                marginTop: -12,
                                marginLeft: -12,
                            }}
                        />
                    )}
                </Button>
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): IActionButtonReduxProps => {
    const disabled = actionButtonDisabled(state);
    const actionButton = getActionButton(state);
    const showSpinner = actionButtonShowSpinner(state);

    return {
        disabled: disabled,
        text: actionButton && actionButton.text,
        icon: actionButton && actionButton.icon,
        showSpinner,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IActionButtonDispatchProps => {
    return {
        actionButtonClick: () => {
            dispatch(ActionButtonClicked());
        },
    };
};

//export default connect<IActionButtonReduxProps, IActionButtonDispatchProps, IActionButtonProps>(mapStateToProps, mapDispatchToProps)(ActionButton);
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ActionButton)
);



// WEBPACK FOOTER //
// ./src/components/ActionButton/ActionButton.tsx